/*
 * Layout  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { offEvent, onEvent } from "@adapptio/lib-shared";
import { useEffect, useState } from "react";
import { TLayoutState } from "./LayoutState";

/**
 * Hooks that returns layout element and handles change
 *
 * @param state Element state
 */
export function useLayoutElement<TState extends TLayoutState>(state: TState): TState {
	const [ element, setElement ] = useState<{ state: TState }>({
		state: state
	});

	useEffect(() => {
		const handleChange = () =>
			setElement({
				state: state
			});

		onEvent(state.onChange, handleChange);

		return () => {
			offEvent(state.onChange, handleChange);
		};
	}, [ state ]);

	return element.state;
}
